export const pages = {
    LOGIN: 'login',
    HOME: 'home',
    SETTING: 'setting',
    ALL_SYSPARAMS: 'all-sysparams'
}